import { Flex } from '@chakra-ui/react';
import LeftArrow from '@components/icons/LeftArrow';
import RightArrow from '@components/icons/RightArrow';
import { useIsMobile } from '@hooks/useIsMobile';
import { useEffect, useRef } from 'react';
import Avatar from './Avatar';

const Avatars = ({ agents, selectedIndex, setSelectedIndex, ...rest }) => {
  const isMobile = useIsMobile();
  const rootRef = useRef(null);
  const selectedAvatarRef = useRef(null);

  useEffect(() => {
    if (selectedAvatarRef) {
      rootRef.current.scrollLeft = selectedAvatarRef.current.offsetLeft - 150;
    }
  }, [selectedIndex]);

  const renderAvatar = (agent, index) => {
    return Avatar({ agent, index, selectedIndex, setSelectedIndex, selectedAvatarRef });
  };

  const renderAvatars = () => {
    return agents.map((agent, index) => renderAvatar(agent, index));
  };

  return (
    <Flex alignItems="center" w="100%" position="relative" justifyContent="space-between" {...rest}>
      <LeftArrow
        onClick={() => {
          setSelectedIndex((prev) => (prev === 0 ? agents.length - 1 : prev - 1));
        }}
      />
      <Flex
        ref={rootRef}
        p={5}
        maxW={`calc(100% - ${(isMobile ? 92 : 200) - 50}px)`}
        overflowX="scroll"
        sx={{
          '::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {renderAvatars()}
      </Flex>
      <RightArrow
        onClick={() => {
          setSelectedIndex((prev) => (prev === agents.length - 1 ? 0 : prev + 1));
        }}
      />
    </Flex>
  );
};

export default Avatars;
